import { Button } from "@/components/ui/button";
import { Trash2, Info } from "lucide-react";
import { CartItem } from "@/types/cart";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface CartItemsListProps {
  cartItems: CartItem[];
  onRemoveItem: (id: string) => void;
}

export const CartItemsList = ({ cartItems, onRemoveItem }: CartItemsListProps) => {
  if (cartItems.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        Le panier est vide
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Alert className="bg-blue-50 border-blue-200">
        <Info className="h-4 w-4 text-blue-500" />
        <AlertDescription className="text-sm text-blue-700">
          Vérifiez les quantités avant de valider votre panier.
        </AlertDescription>
      </Alert>

      {cartItems.map((item) => (
        <div
          key={item.id}
          className="flex items-center justify-between p-4 border rounded-lg"
        >
          <div className="space-y-1">
            <h3 className="font-medium">{item.stock_item.data.name}</h3>
            <p className="text-sm text-gray-500">
              Quantité: {item.quantity} x {item.stock_item.data.price} FCFA
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onRemoveItem(item.id)}
            className="text-red-500 hover:text-red-700"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
};